import 'react-international-phone/style.css';
import { MenuItem, Select, TextField, Typography, Box, BaseTextFieldProps } from '@mui/material';
import React from 'react';
import {
	CountryIso2,
	defaultCountries,
	FlagEmoji,
	parseCountry,
	usePhoneInput,
} from 'react-international-phone';
import styled from 'styled-components';

// Styled Components
const StyledSelectContainer = styled(TextField)`
	input {
		height: 48px;
		width: 85px;
		border: 1.5px solid ${(props) => (props.error ? 'red' : '#e9e9e9')};
		border-radius: 4px;
		box-sizing: border-box;
		background-color: #fff;
		display: flex;
		padding-left: 24px;
		align-items: center;
		&:focus {
			border: 1.5px solid #acacac;
		}
	}
`;

const StyledTextFieldContainer = styled(TextField)`
	input {
		height: 48px;
		width: 233px;
		border: 1.5px solid ${(props) => (props.error ? 'red' : '#e9e9e9')};
		border-radius: 4px;
		box-sizing: border-box;
		display: flex;
		padding-left: 20px;
		align-items: center;
		background: #fff;

		&:focus {
			border: 1.5px solid ${(props) => (props.error ? 'red' : '#acacac')};
		}
	}
`;

export interface MUIPhoneProps {
	countryCode: string;
	phoneNumber: string;
	setPhoneNumber: (phone: string) => void;
	onChange: (phone: string) => void;
	error: string;
	setError: (data: string) => void;
}

export const PhoneInput: React.FC<MUIPhoneProps> = ({
	countryCode,
	phoneNumber,
	setPhoneNumber,
	onChange,
	error,
	setError,
}) => {
	const handlePhoneNumberChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const inputValue: string = event.target.value;

		const numericRegex = /^[0-9]*$/;
		if (inputValue.length <= 10) {
			if (inputValue === '' || numericRegex.test(inputValue)) {
				setPhoneNumber(inputValue);
				setError('');
			}
		}
	};
	return (
		<Box
			style={{
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				gap: '8px',
				width: '340px',
				height: '48px',
			}}
		>
			<StyledSelectContainer
				variant="standard"
				error={error !== ''}
				value={countryCode}
				type="tel"
				InputProps={{
					disableUnderline: true,
					classes: {
						root: 'MuiInputBase-root',
					},
				}}
			/>

			<StyledTextFieldContainer
				variant="standard"
				color="primary"
				placeholder="Mobile number"
				value={phoneNumber}
				error={error !== ''}
				onChange={handlePhoneNumberChange}
				type="tel"
				InputProps={{
					disableUnderline: true,
					classes: {
						root: 'MuiInputBase-root',
					},
				}}
			/>
		</Box>
	);
};
